import TrailmixAddModal from "th/trailmixAddModal";

export { TrailmixAddModal };

customElements.define(
  "th-trailmix-add-modal",
  TrailmixAddModal.CustomElementConstructor
);
